export default "__VITE_ASSET__v1Yws6FJ__"